import React from 'react';
import { useSettingsContext } from './context';
import MainLayoutIgniter from '../../common/mainLayout';
import { Heading2 } from '../../../../libs/uiKit/globalStyledComponents';
import { FieldsBuilder } from '../../../../libs/uiKit/fieldsBuilder';
import Button from '../../../../libs/uiKit/button';
import { StyledSettingsWrapper, StyledStepFormWrapper, StyledStepWrapper } from './styles';
import ChangeLogModal from "../../roles/widgets/changeLogModal";
import ConfirmPopup from "../../../widgets/confirmPopup";

const SettingsUi: React.FC = () => {



	const { form, onFormSubmit, isLoading, stateIsOpenHistory, setIsOpenHistory, historyData, isDisabledEdit, stateCopyConfirmModal, setCopyConfirmModal, onCopyFromConfirmed } = useSettingsContext();

	// @ts-ignore
    return (
		<MainLayoutIgniter>
			<StyledSettingsWrapper>
				<StyledStepWrapper>
					<Heading2>Настройки</Heading2>
					<form onSubmit={onFormSubmit}>
						<StyledStepFormWrapper>
							<FieldsBuilder {...form} />
						</StyledStepFormWrapper>
						<Button isLoading={isLoading} isDisabled={isDisabledEdit} type='submit' appearance='filled'>
							Сохранить
						</Button>
					</form>
				</StyledStepWrapper>
			</StyledSettingsWrapper>
			<ChangeLogModal
				onClose={() => setIsOpenHistory(false)}
				isOpen={stateIsOpenHistory}
				data={historyData}
				header='История изменения настроек'
			/>
            <ConfirmPopup
                isOpen={stateCopyConfirmModal}
                onClose={() => setCopyConfirmModal(false)}
                text={<span>Текущие настройки будут заменены.<br/>Вы уверены?</span>}
                confirmCallback={onCopyFromConfirmed}
            />
		</MainLayoutIgniter>
	);
};

export default React.memo(SettingsUi);
